import { format } from 'date-fns';
import { isEmpty, isNil } from 'ramda';

import { DAY, MONTH, QUARTER, WEEK, YEAR, DATE_FIELD_API_PREFIX } from 'constants/StatisticsConstants';
import { GROUP_BY_API_SUFFIX } from 'modules/statistics/groupBy';

import { getWeekYearLabel } from './weekRange';

const getDayYearLabel = (year, month, day) => {
  if (!isEmpty(year) && !isEmpty(day) && !isNil(day) && !Number.isNaN(day) && !isEmpty(month)) {
    return format(new Date(year, month, day), 'EEE P');
  }
  return '';
};

const getWeekYearLabelAsNumber = (year, week) => {
  if (!isEmpty(year) && !isEmpty(week) && !isNil(week) && !Number.isNaN(week)) {
    return `${week} - ${year}`;
  }
  return '';
};

export const getMonthYearLabel = (year, month) => {
  if (!isEmpty(year) && !isEmpty(month) && !isNil(month) && !Number.isNaN(month)) {
    return format(new Date(year, month), 'MMMM yyyy');
  }
  return '';
};

const getQuarterYearLabelAsNumber = (year, quarter) => {
  if (!isEmpty(year) && !isEmpty(quarter) && !isNil(quarter) && !Number.isNaN(quarter)) {
    return `${quarter} - ${year}`;
  }

  return '';
};

export const getWeekLabel = (intl, year, week) => ({
  name: `${intl.formatMessage({ id: 'group_by.shortWeek', defaultMessage: 'Week' })} ${getWeekYearLabelAsNumber(year, week)}`,
  tooltipLabel: getWeekYearLabel(year, week),
});

export const getQuarterLabel = (intl, year, quarter) => ({
  name: `${intl.formatMessage({ id: 'group_by.quarter', defaultMessage: 'Quarter' })} ${getQuarterYearLabelAsNumber(year, quarter)}`,
});

const getDateFieldKey = (dateField, suffix) => {
  const prefix = DATE_FIELD_API_PREFIX[dateField] ?? DATE_FIELD_API_PREFIX.createdOn;
  return `${prefix}${suffix}`;
};

export const getDateLabel = (data, groupBy, intl, dateField) => {
  switch (groupBy) {
    case DAY: {
      const key = getDateFieldKey(dateField, GROUP_BY_API_SUFFIX[DAY]);
      const [year, month, day] = (data[key] ?? '').split('-');
      return {
        name: getDayYearLabel(year, Number(month) - 1, Number(day)),
      };
    }
    case WEEK: {
      const key = getDateFieldKey(dateField, GROUP_BY_API_SUFFIX[WEEK]);
      const [year, week] = (data[key] ?? '').split('-');
      return getWeekLabel(intl, year, week);
    }
    case MONTH: {
      const key = getDateFieldKey(dateField, GROUP_BY_API_SUFFIX[MONTH]);
      const [year, month] = (data[key] ?? '').split('-');
      return { name: getMonthYearLabel(year, Number(month) - 1) };
    }
    case QUARTER: {
      const key = getDateFieldKey(dateField, GROUP_BY_API_SUFFIX[QUARTER]);
      const [year, quarter] = (data[key] ?? '').split('-');
      return getQuarterLabel(intl, year, quarter);
    }
    case YEAR: {
      const key = getDateFieldKey(dateField, GROUP_BY_API_SUFFIX[YEAR]);
      return { name: data[key] ?? '' };
    }
    default:
      break;
  }
  return undefined;
};
